module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/website_mobile-c082fa7f68df34f1a054b1e251ae2b7d.png";